var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLongDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.04 5.048l-.998.998L3.467 7.62l-.362.362h.843l-.998-.998L1.375 5.41l-.362-.362c-.22-.22-.625-.237-.843 0a.606.606 0 000 .843l.998.997 1.575 1.576.362.361a.605.605 0 00.843 0l.998-.997 1.573-1.575.362-.362c.22-.22.237-.626 0-.843a.606.606 0 00-.841 0z",
    fill: "#58B847"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12 8.404V1.04c0-.142.002-.285 0-.426V.596c0-.311-.274-.61-.595-.595-.323.014-.596.262-.596.595v1.559-.261 6.51c0 .311.274.61.596.595.323-.014.595-.262.595-.595z",
    fill: "#58B847"
  })));
}
export default SvgLongDown;